<template>
	<div class="base_scroll_page" v-loading="loading">
		<div class="b_scroller">
			<!-- action -->
			<div style="font-size: 0;text-align: right;">
				<el-button type="primary" @click="handleAddClick">新增</el-button>
			</div>
			<!-- action end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="order"
						label="序号"
					>
					</el-table-column>
					<el-table-column
						prop="sortLabel"
						label="分类"
					>
					</el-table-column>
					<el-table-column
						prop="title"
						label="标题"
					>
					</el-table-column>
					<el-table-column
						label="封页图"
					>
						<template slot-scope="scope">
							<img :src="scope.row.cover" alt="" style="width: 48px;">
						</template>
					</el-table-column>
					<el-table-column
						prop="publisher"
						label="发布人"
					>
					</el-table-column>
					<el-table-column
						prop="time"
						label="时间"
					>
					</el-table-column>
					<el-table-column
						label="操作"
						width="300"
					>
						<template slot-scope="scope">
							<el-button
								@click="handleViewClick(scope.row)"
							>查看</el-button>
							<el-button
								@click="handleUpdateClick(scope.row)"
							>修改</el-button>
							<el-button
								style="color: #f00;"
								@click="handleDeleteClick(scope.row)"
							>删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination 
						layout="total, prev, pager, next, jumper" 
						next-text="下一页" 
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange"
					>
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
		
		<!-- 新增弹框 -->
		<add v-model="add_display" @onSuccess="addSuccess"></add>
		<!-- 新增弹框 end -->
		
		<!-- 查看弹框 -->
		<view-case v-model="view_display" :obj="view_data"></view-case>
		<!-- 查看弹框 end -->
		
		<!-- 修改弹框 -->
		<update v-model="update_display" :obj="update_data" @onSuccess="updateSuccess"></update>
		<!-- 修改弹框 end -->
	</div>
</template>

<script>
	import Api from '../../../../../api/index.js';
	import Add from './components/add.vue';
	import ViewCase from './components/view.vue';
	import Update from './components/update.vue';
	
	export default{
		mounted() {
			this.getData();
		},
		data() {
			return{
				loading: false,
				tableData: [],
				total: 0,
				currentPage: 1,
				
				add_display: false,
				
				view_display: false,
				view_data: {},
				
				update_display: false,
				update_data: {}
			}
		},
		methods: {
			/******************** @Events *************************/
			// 切换页码
			handlePageChange(page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.getData();
				}
			},
			// 点击新增
			handleAddClick() {
				this.add_display = true;
			},
			// 点击查看
			handleViewClick(data) {
				this.view_data = {...data};
				this.view_display = true;
			},
			// 点击修改
			handleUpdateClick(data) {
				this.update_data = {...data};
				this.update_display = true;
			},
			// 新增成功
			addSuccess() {
				this.getData();
			},
			// 修改成功
			updateSuccess() {
				this.getData();
			},
			// 点击删除
			handleDeleteClick(obj) {
				const that = this;
				that.$confirm(
					'此操作将删除该成功案例，是否继续?', 
					'提示', 
					{
						type: 'warning'
					}
				).then(
					() => {
						that.deleteCase(obj.id);
					}
				).catch(
					() => {}
				);
			},
			
			/******************** @Function *************************/
			// 获取数据
			getData() {
				const that = this;
				that.loading = true;
				let requestData = {
					pageNum: that.currentPage,
					pageSize: 10
				};
				Api.findIAssistantCaseByPage(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						let list = [];
						res.data.data.records.forEach(v => {
							list.push({
								id: v.id,
								order: v.orderNo,
								sortId: parseInt(v.catId),
								sortLabel: v.catName,
								title: v.caseTitle,
								cover: v.caseImg,
								publisher: v.buserName,
								time: v.createTs,
								content: v.caseCount
							});
						});
						that.tableData = list;
						that.total = res.data.data.total;
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 删除成功案例
			deleteCase(id) {
				const that = this;
				that.loading = true;
				Api.deleteIAssistantCase(id).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.$message.success(res.data.message);
						that.getData();
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		components: {
			Add,
			ViewCase,
			Update
		}
	}
</script>

<style>
</style>
